import {
	BookOpenText,
	MessageCircleQuestion,
	MessageCircleWarning,
} from 'lucide-react'
import React from 'react'
import {UserRole} from 'types'

// define a NavItem prop
export interface NavItem {
	label: string
	name: string
	href: string
	params?: (id?: string) => string
	icon: React.JSX.Element
}
export interface NavItemGroup {
	navItemGroup: NavItem[]
}

export interface FeedbackItem {
	label: string
	href: string
	icon: React.JSX.Element
	name: string
}

export const getFeedbackItemGroup = (userRoles: string[]) => {
	const feedbackGroup: FeedbackItem[] = [
		{
			label: 'Report an error',
			href:
				userRoles.includes(UserRole.CPQ_INTERNAL_OY) ? '/cpq/help/report' : (
					'https://forms.clickup.com/25753540/f/rhxy4-14098/9QZ1NZ6EEMXA16MUH2'
				),
			icon: <MessageCircleWarning />,
			name: 'report-error',
		},
		{
			label: 'Make a suggestion',
			href:
				userRoles.includes(UserRole.CPQ_INTERNAL_OY) ? '/cpq/help/suggest' : (
					'https://forms.clickup.com/25753540/f/rhxy4-14478/CT5BLJ333ABAJSNHKO'
				),
			icon: <MessageCircleQuestion />,
			name: 'make-suggestion',
		},
		{
			label: 'Documentation',
			href: (() => {
				if (userRoles.includes(UserRole.CPQ_EXTERNAL_CONSULTANT)) {
					switch (import.meta.env.VITE_ENVIRONMENT) {
						case 'local':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'preview':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'develop':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'staging':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'production':
							return 'https://docs.vahterus.cloud'
						default:
							return 'https://docs.vahterus.cloud'
					}
				}
				if (userRoles.includes(UserRole.CPQ_EXTERNAL_DISTRIBUTOR)) {
					switch (import.meta.env.VITE_ENVIRONMENT) {
						case 'local':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'preview':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'develop':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'staging':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'production':
							return 'https://docs.vahterus.cloud'
						default:
							return 'https://docs.vahterus.cloud'
					}
				}
				if (userRoles?.includes(UserRole.CPQ_INTERNAL_OY)) {
					switch (import.meta.env.VITE_ENVIRONMENT) {
						case 'local':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'preview':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'develop':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'staging':
							return 'https://develop.docs.vahterus.dev/collection/cpq-documentation-mwpRQt06cn'
						case 'production':
							return 'https://docs.vahterus.cloud'
						default:
							return 'https://docs.vahterus.cloud'
					}
				}
				return 'https://docs.vahterus.cloud'
			})(),
			icon: <BookOpenText />,
			name: 'documentation',
		},
	]

	return feedbackGroup
}
